import { render, staticRenderFns } from "./Beeswarm.vue?vue&type=template&id=84e284c0"
import script from "./Beeswarm.vue?vue&type=script&lang=js"
export * from "./Beeswarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports